import {useState, useCallback} from 'react'
import {useTranslation} from "react-i18next";

import {ConfirmationDialog} from "./ConfirmationDialog";


const useConfirmationDialog = () => {
    const {t} = useTranslation('components')
    const _defaultOpts = {
        title: t("askConfirmation.title"),
        description: t("askConfirmation.description"),
        confirmationText: t('askConfirmation.confirmationText'),
        cancellationText: t('askConfirmation.cancellationText'),
        disableClose: false,
        showDoNotAskMeLater: false,
        defaultDoNotAskMeLater: false,
        doNotAskMeLaterMessage: t("askConfirmation.doNotAskMeLaterMessage"),
        onConfirm: () => console.warn('[ConfirmDialog] onConfirm in not defined')
    };

    const [isOpen, setOpen] = useState(false);
    const [options, setOptions] = useState(_defaultOpts);

    const onClose = useCallback(() => {
        setOpen(false);
    }, []);

    const askConfirmation = useCallback((opts) => {
        setOptions(Object.assign({}, _defaultOpts, opts));
        setOpen(true);
    }, []);

    return {
        isOpen,
        options,
        onClose,
        askConfirmation
    }
};

export {useConfirmationDialog, ConfirmationDialog}